import mdrFileStore from './get-mdr-file';
import bckoSharedStore from './get-bcko';
import cmerSharedStore from './get-cmer';
import channelProviderSharedStore from './get-channel-provider';
import closedMerchantCategorySharedStore from './get-closed-merchant-category';

export default {
  mdrFile: mdrFileStore,
  bckoShared: bckoSharedStore,
  cmerShared: cmerSharedStore,
  channelProviderShared: channelProviderSharedStore,
  closedMerchantCategoryShared: closedMerchantCategorySharedStore,
};